import { jsxs as p, jsx as s } from "react/jsx-runtime";
import * as b from "react";
import o, { memo as w } from "react";
import { Tooltip as P, Progress as j } from "antd";
import { I as x } from "./AntdIcon-DR2yozD3.js";
var M = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "code", theme: "outlined" };
function h() {
  return h = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, h.apply(this, arguments);
}
const C = (t, e) => /* @__PURE__ */ b.createElement(x, h({}, t, {
  ref: e,
  icon: M
})), O = /* @__PURE__ */ b.forwardRef(C);
process.env.NODE_ENV !== "production" && (O.displayName = "CodeOutlined");
var y = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, v = o.createContext && /* @__PURE__ */ o.createContext(y), N = ["attr", "size", "title"];
function E(t, e) {
  if (t == null) return {};
  var r = _(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function _(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function u() {
  return u = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, u.apply(this, arguments);
}
function g(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? g(Object(r), !0).forEach(function(n) {
      S(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : g(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function S(t, e, r) {
  return e = I(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function I(t) {
  var e = B(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function B(t, e) {
  if (typeof t != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function z(t) {
  return t && t.map((e, r) => /* @__PURE__ */ o.createElement(e.tag, d({
    key: r
  }, e.attr), z(e.child)));
}
function l(t) {
  return (e) => /* @__PURE__ */ o.createElement(H, u({
    attr: d({}, t.attr)
  }, e), z(t.child));
}
function H(t) {
  var e = (r) => {
    var {
      attr: n,
      size: a,
      title: i
    } = t, f = E(t, N), m = a || r.size || "1em", c;
    return r.className && (c = r.className), t.className && (c = (c ? c + " " : "") + t.className), /* @__PURE__ */ o.createElement("svg", u({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, f, {
      className: c,
      style: d(d({
        color: t.color || r.color
      }, r.style), t.style),
      height: m,
      width: m,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && /* @__PURE__ */ o.createElement("title", null, i), t.children);
  };
  return v !== void 0 ? /* @__PURE__ */ o.createElement(v.Consumer, null, (r) => e(r)) : e(y);
}
function U(t) {
  return l({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }, child: [] }] })(t);
}
function W(t) {
  return l({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" }, child: [] }] })(t);
}
function $(t) {
  return l({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, child: [] }] })(t);
}
function D(t) {
  return l({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" }, child: [] }] })(t);
}
function G(t) {
  return l({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" }, child: [] }] })(t);
}
const V = ({ fileInQueue: t }) => {
  const { status: e, uploadProgress: r, isEncoding: n, encodeProgress: a, file: i } = t, { name: f } = i;
  return /* @__PURE__ */ p("div", { className: "at-grid at-grid-cols-2 at-place-content-center at-mb-2", children: [
    /* @__PURE__ */ p(
      P,
      {
        title: n ? "Bunny 編碼中" : "檔案上傳中",
        zIndex: 1e4,
        className: "at-flex at-items-center at-gap-2",
        children: [
          n ? /* @__PURE__ */ s(O, { className: "at-size-3.5" }) : /* @__PURE__ */ s(D, { className: "at-size-3.5" }),
          /* @__PURE__ */ s("p", { className: "at-flex-1 at-m-0 at-text-xs at-truncate", children: f })
        ]
      }
    ),
    /* @__PURE__ */ s(
      j,
      {
        size: "small",
        percent: n ? a : r,
        status: {
          uploading: "active",
          done: "success",
          error: "exception",
          removed: "normal"
        }[e] || "active"
      }
    )
  ] });
}, A = w(V);
export {
  A as F,
  l as G,
  $ as M,
  G as a,
  W as b,
  U as c
};
